"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitAdManagerAction = void 0;
var tslib_1 = require("tslib");
var i18n_1 = require("@dp-instant/i18n");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var AdManagerBase_1 = require("./AdManagerBase");
var inversify_1 = require("inversify");
var app_1 = require("../app");
var InitAdManagerAction = (function (_super) {
    tslib_1.__extends(InitAdManagerAction, _super);
    function InitAdManagerAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InitAdManagerAction.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i18n_1.Localize.addTemplates({
                            video_ad_failed: {
                                default: "Video AD Failed",
                                localizations: {
                                    ru_RU: "Ошибка видеорекламы",
                                    es_ES: "Error en el anuncio",
                                    es_LA: "Fallo en el anuncio",
                                    pt_PT: "Erro no anúncio",
                                    pt_BR: "Erro no vídeo de anúncio",
                                    fr_FR: "Échec de la pub vidéo",
                                    de_DE: "Videowerbung nicht verf.",
                                    zh_CN: "视频广告错误",
                                    zh_TW: "影片廣告錯誤",
                                    ja_JP: "動画広告の再生に失敗しました",
                                    ko_KR: "비디오 광고 시청 실패",
                                    it_IT: "Spot video non disponibile",
                                    pl_PL: "Reklama wideo błędna",
                                    tr_TR: "Reklam videosu gösterilemedi",
                                    th_TH: "แสดงวิดีโอโฆษณาไม่สำเร็จ",
                                    hi_IN: "वीडियो विज्ञापन विफल रहा",
                                    vi_VN: "Quảng cáo video không thành công",
                                    id_ID: "Iklan Video gagal",
                                    ms_MY: "Video AD gagal"
                                }
                            },
                            no_video_ad: {
                                default: "No Video ADs at the moment, sorry...",
                                localizations: {
                                    ru_RU: "Видоереклама недоступна",
                                    es_ES: "¡Vaya! No hay anuncios ahora.",
                                    es_LA: "Qué pena, no hay anuncios disponibles.",
                                    pt_PT: "Infelizmente não há anúncios neste momento.",
                                    pt_BR: "Nenhum vídeo de anúncio no momento. Foi mal!",
                                    fr_FR: "Aucune pub vidéo pour l'instant...",
                                    de_DE: "Leider gibt es keine Videowerbungen im Moment …",
                                    zh_CN: "目前没有视频广告，抱歉……",
                                    zh_TW: "目前沒有影片廣告，抱歉……",
                                    ja_JP: "現在、動画広告はありません、ご理解ください",
                                    ko_KR: "죄송합니다, 지금 시청 가능한 비디오 광고가 없습니다",
                                    it_IT: "Non ci sono spot video disponibili al momento.",
                                    pl_PL: "W tej chwili brak reklam wideo, przykro nam…",
                                    tr_TR: "Üzgünüz, şu anda reklam videosu yok.",
                                    th_TH: "ขณะนี้ไม่มีวิดีโอโฆษณาพร้อมให้บริการ ขออภัยด้วย...",
                                    hi_IN: "क्षमा करें, इस समय कोई वीडियो विज्ञापन नहीं है",
                                    vi_VN: "Rất tiếc, hiện tại không có quảng cáo video…",
                                    id_ID: "Tidak ada iklan Video saat ini, maaf…",
                                    ms_MY: "Tiada Video AD buat masa ini, maaf..."
                                }
                            },
                            video_ad_cancelled: {
                                default: "Video AD Cancelled",
                                localizations: {
                                    ru_RU: "Вы отменили просмотр видеорекламы",
                                    es_ES: "Anuncio cancelado",
                                    es_LA: "Anuncio cancelado",
                                    pt_PT: "Anúncio cancelado",
                                    pt_BR: "Vídeo de anúncio cancelado",
                                    fr_FR: "Pub vidéo annulée",
                                    de_DE: "Videowerbung abgebr.",
                                    zh_CN: "视频广告已取消",
                                    zh_TW: "影片廣告已取消",
                                    ja_JP: "動画広告がキャンセルされました",
                                    ko_KR: "비디오 광고 시청 취소",
                                    it_IT: "Spot video annullato",
                                    pl_PL: "Reklama wideo anulowana",
                                    tr_TR: "Reklam videosu iptal edildi",
                                    th_TH: "วิดีโอโฆษณาถูกยกเลิก",
                                    hi_IN: "वीडियो विज्ञापन रद्द कर दिया",
                                    vi_VN: "Đã hủy quảng cáo video",
                                    id_ID: "Iklan Video dibatalkan",
                                    ms_MY: "Video AD dibatalkan"
                                }
                            }
                        });
                        return [4, Promise.all([
                                this.ads.preloadNextInter(AdManagerBase_1.AdManagerBase.config.ids.INTER),
                                this.ads.preloadNextReward(AdManagerBase_1.AdManagerBase.config.ids.REWARD)
                            ])];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesAds.manager),
        tslib_1.__metadata("design:type", Object)
    ], InitAdManagerAction.prototype, "ads", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], InitAdManagerAction.prototype, "social", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesApp.pageModel),
        tslib_1.__metadata("design:type", app_1.PageModel)
    ], InitAdManagerAction.prototype, "page", void 0);
    InitAdManagerAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], InitAdManagerAction);
    return InitAdManagerAction;
}(core_1.Action));
exports.InitAdManagerAction = InitAdManagerAction;
//# sourceMappingURL=InitAdManagerAction.js.map